import React, { useEffect, useState } from "react";
import api, { brl, fmtDate } from "@/lib/api";
import { Trophy, Crown } from "lucide-react";

export default function Winners() {
  const [winners, setWinners] = useState([]);
  useEffect(() => { api.get("/winners").then(({ data }) => setWinners(data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="mb-10 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-amber-200/80 mb-2">Hall da Fama</p>
        <h1 className="heading text-3xl sm:text-5xl font-extrabold text-slate-50">Nossos <span className="gold-gradient-text">Ganhadores</span></h1>
        <p className="mt-4 text-slate-400 max-w-2xl mx-auto">Prêmios entregues com transparência total. Cada rifa Rifa RMC segue a Loteria Federal do Brasil.</p>
      </div>

      {winners.length === 0 ? (
        <div className="card-luxury rounded-3xl p-16 text-center">
          <Crown className="w-10 h-10 text-amber-300 mx-auto mb-4" />
          <p className="text-slate-400">Ainda não há ganhadores. Seja o próximo!</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {winners.map((w) => (
            <div key={w.raffle_id} className="card-luxury rounded-3xl overflow-hidden">
              <div className="aspect-video relative">
                {w.images?.[0] && (
                  <img src={w.images[0].startsWith("http") ? w.images[0] : `${process.env.REACT_APP_BACKEND_URL}${w.images[0]}`} alt={w.title} className="w-full h-full object-cover" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" />
                <div className="absolute top-3 left-3 glass rounded-full px-3 py-1 flex items-center gap-1.5 text-xs text-amber-200">
                  <Trophy className="w-3.5 h-3.5" /> Bilhete #{String(w.winner_ticket).padStart(6, "0")}
                </div>
              </div>
              <div className="p-5">
                <h3 className="heading text-lg font-bold text-slate-50">{w.title}</h3>
                <p className="text-xs text-slate-400 mt-1">Sorteada em {fmtDate(w.drawn_at || w.draw_date)}</p>
                <div className="mt-4 flex items-center justify-between">
                  <div>
                    <p className="text-xs uppercase tracking-widest text-slate-400">Vencedor</p>
                    <p className="text-slate-100 font-semibold">{w.winner_name || "—"}</p>
                  </div>
                  <div className="heading gold-gradient-text font-bold text-lg">{brl(w.prize_value)}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
